import { Typography, Paper, styled } from "@mui/material";

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  backgroundColor: "rgba(255, 255, 255, 0.05)",
  border: "1px solid rgba(255, 255, 255, 0.1)",
  borderRadius: "10px",
}));

const BalanceCard = ({ label, amount, symbol }) => {
  const formattedAmount = Number(amount).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return (
    <StyledPaper>
      <Typography variant="h6" color="text.primary">
        {label}
      </Typography>
      <Typography variant="h4" color="text.secondary" fontWeight={600}>
        {formattedAmount} {symbol}
      </Typography>
    </StyledPaper>
  );
};

export default BalanceCard;